import {
  effectiveVatRateBp,
  priceCart,
  unitAllowsDecimals,
  type BusinessSummary,
  type Discount,
  type PricedCart,
  type PromotionRule,
} from '@tengesa/shared';
import type { ProductDto } from '../../lib/types';

export interface CartLine {
  key: string;
  product: ProductDto;
  qtyMilli: number;
  unitPriceCents: number | null;
  manualDiscount: Discount | null;
}

export interface Cart {
  lines: CartLine[];
  saleDiscount: Discount | null;
}

export const emptyCart = (): Cart => ({ lines: [], saleDiscount: null });

/** Same pricing engine the server uses, so the screen never disagrees with the receipt. */
export function priceLocal(cart: Cart, business: BusinessSummary, promotions: PromotionRule[] = []): PricedCart {
  return priceCart(
    cart.lines.map((l) => ({
      key: l.key,
      productId: l.product.id,
      categoryId: l.product.categoryId,
      qtyMilli: l.qtyMilli,
      unitPriceCents: l.unitPriceCents ?? l.product.priceCents,
      vatRateBp: effectiveVatRateBp(business.vatRegistered, l.product.vatCategory, business.standardVatRateBp),
      wholeUnits: !unitAllowsDecimals(l.product.unit),
      manualDiscount: l.manualDiscount,
    })),
    { saleDiscount: cart.saleDiscount, promotions },
  );
}

let counter = 0;
export function addToCart(cart: Cart, product: ProductDto, qtyMilli: number): Cart {
  const weighed = unitAllowsDecimals(product.unit);
  const existing = !weighed && cart.lines.find((l) => l.product.id === product.id && l.unitPriceCents == null && !l.manualDiscount);
  if (existing) {
    return { ...cart, lines: cart.lines.map((l) => (l === existing ? { ...l, qtyMilli: l.qtyMilli + qtyMilli } : l)) };
  }
  return { ...cart, lines: [...cart.lines, { key: `l${Date.now()}-${counter++}`, product, qtyMilli, unitPriceCents: null, manualDiscount: null }] };
}
